module.exports = __webpack_public_path__ + "static/media/W19-1155_Beyond_Meat_3.99_Desktop_2396x1473.fc7fa995.jpg";